export default "__VITE_ASSET__zwIs5lFD__"